/**
 * Enum representing the different types of content that can be loaded in the patient tab.
 */
export enum PatientTabContext {
    Demographics = 'Demographics',
    ReviewPastNotes = 'ReviewPastNotes',
    FullNoteDashboard = 'FullNoteDashboard',
}
